import { useState } from 'preact/hooks';
import { useLocation } from 'preact-iso';
import { BrandStripe } from '../../components/BrandStripe.jsx';
import { Button } from '../../components/Button.jsx';
import { useAuth } from '../../hooks/useAuth.jsx';

export const LoginPage = () => {
  const { login } = useAuth();
  const { route } = useLocation();
  const [username, setUsername] = useState('');
  const [pin, setPin] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(username.trim(), pin);
      route('/', true);
    } catch (err) {
      setError(err.message ?? 'Login failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div class="flex min-h-screen items-center justify-center bg-bg-base px-4">
      <form
        onSubmit={onSubmit}
        class="surface-card w-full max-w-sm space-y-5 p-7"
      >
        <div class="flex items-center gap-3">
          <BrandStripe height={22} width={5} />
          <div>
            <h1 class="m-0 font-serif text-xl font-medium text-text-primary">
              Sign in
            </h1>
            <p class="m-0 text-[13px] text-text-tertiary">brandpack tools</p>
          </div>
        </div>

        <label class="block">
          <span class="text-[13px] font-semibold text-text-tertiary">Username</span>
          <input
            class="mt-1.5 block w-full rounded-md border border-border-strong bg-bg-base px-3 py-2 text-sm font-medium text-text-primary placeholder:text-text-muted focus:border-brand focus:outline-none focus:ring-1 focus:ring-brand"
            autoFocus
            value={username}
            onInput={(e) => setUsername(e.currentTarget.value)}
            autoComplete="username"
          />
        </label>

        <label class="block">
          <span class="text-[13px] font-semibold text-text-tertiary">PIN</span>
          <input
            class="mt-1.5 block w-full rounded-md border border-border-strong bg-bg-base px-3 py-2 font-mono tracking-[0.4em] text-text-primary focus:border-brand focus:outline-none focus:ring-1 focus:ring-brand"
            type="password"
            inputMode="numeric"
            pattern="\d{4,8}"
            value={pin}
            onInput={(e) => setPin(e.currentTarget.value)}
            autoComplete="current-password"
          />
        </label>

        {error && (
          <p class="m-0 text-[13px] font-semibold text-ink-magenta" role="alert">
            {error}
          </p>
        )}

        <Button variant="primary" class="w-full" disabled={busy || !username || !pin}>
          {busy ? 'Signing in…' : 'Sign in'}
        </Button>
      </form>
    </div>
  );
};
